import HeaderLogo from '@/components/decoration/HeaderLogo';
import { motion } from 'framer-motion';
import { FC, Suspense } from 'react';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';
import { HeaderNavigation } from '../header/Header';
import RightHandSideNavSection from '../header/RightHandSideNavSection';
import { NavigationSidebar } from '../sidebar/NavigationSidebar';
import { Loading } from '@/components/loading/Loading';

export const FullWidth: FC = () => {
  return (
    <main className="flex h-screen w-full flex-col overflow-hidden">
      <header className="border-secondary-std border-b">
        <div className="flex w-full items-center justify-between px-4 py-3 sm:px-8">
          <motion.div layoutId="navigation" className="flex items-center gap-5">
            <Link to="/">
              <HeaderLogo />
            </Link>
            <HeaderNavigation />
          </motion.div>
          <RightHandSideNavSection />
        </div>
      </header>
      <div className="flex-1 overflow-hidden flex">
        <NavigationSidebar />
        <div className=" flex-1 bg-gradient-to-b from-[#B4EEFF33] to-[#FFEFDD33] flex overflow-hidden flex-col">
          <Suspense fallback={<Loading className="my-auto" />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </main>
  );
};
